var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("ui-modal", {
        attrs: {
          shown: _vm.shown,
          id: "lightbox-photo-guidelines",
          "no-cancel": "",
          "no-confirm": "",
          "handle-close": _vm.close,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "header",
              fn: function () {
                return [
                  _c("div", [
                    _c("h5", { staticClass: "mb-3 text-center" }, [
                      _vm._v("Photo Guidelines"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "tabs container my-0 px-0",
                        attrs: { role: "tablist" },
                      },
                      [
                        _c(
                          "ul",
                          { staticClass: "tabs__list" },
                          _vm._l(_vm.tabs, function (tab) {
                            return _c(
                              "li",
                              {
                                key: tab,
                                staticClass: "tabs__item tabs__item--summary",
                                class: { active: _vm.activeTab === tab },
                                attrs: { role: "presentation" },
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass: "tabs__link",
                                    attrs: { href: "#", role: "tab" },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.setActiveTab(tab)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                              " +
                                        _vm._s(_vm.getTabTitle(tab)) +
                                        "\n                          "
                                    ),
                                  ]
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ]
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
            {
              key: "body",
              fn: function () {
                return [
                  _c(
                    "div",
                    { key: _vm.activeTabType },
                    [_vm._t(_vm.activeTabType)],
                    2
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }